<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import { queryConfig } from "@/api/config";
import { getMyUserInfo } from "@/api/user";
export default {
  name: "App",
  mounted() {
    // App 根组件 mounted 只在「首次进入应用」或「浏览器手动刷新」时触发
    // 路由跳转不会再触发，因此适合用来做刷新时的用户信息拉取
    this.fetchPrivacyPolicy();
    this.fetchUserInfoOnRefresh();
  },
  methods: {
    async fetchPrivacyPolicy() {
      try {
        const res = await queryConfig({
          businessKey: "",
          configKeyList: ["customer_service_phone", "customer_service_time"],
        });
        if (res.code == 200) {
          localStorage.setItem("customer_service_phone", res.data[0].configValue);
          localStorage.setItem("customer_service_time", res.data[1].configValue);
        }
      } catch (error) {
        console.error("获取客服电话失败", error);
      }
    },
    async fetchUserInfoOnRefresh() {
      // 未登录则不请求，避免触发 401
      const token = localStorage.getItem("token");
      if (!token) return;
      try {
        const res = await getMyUserInfo();
        if (res.code == 200 && res.data) {
          localStorage.setItem("userInfo", JSON.stringify(res.data));
          localStorage.setItem("userRes", JSON.stringify(res.data));
        }
      } catch (error) {
        console.error("刷新页面获取用户信息失败", error);
      }
    },
  },
};
</script>

<style></style>
